import { render, staticRenderFns } from "./subTitleSection.vue?vue&type=template&id=206398c4"
import script from "./subTitleSection.vue?vue&type=script&lang=js"
export * from "./subTitleSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports